import SideBar from '../../components/global/SideBar';
import './index.css';
import { TermsAndConditions } from '@beholos/holoscommon';

export default function TermsAndConditionsPage() {

  return (
    <div className="flex h-[calc(100vh-80px)] w-screen overflow-hidden">
      <div className="hidden md:block md:w-80 lg:w-96 h-full overflow-y-auto">
        <SideBar />
      </div>

      <div className="flex-1 h-full overflow-y-auto bg-gray-100 p-6">
        <TermsAndConditions />
      </div>
    </div>
  );
}
